import { render, staticRenderFns } from "./PermissionTree.vue?vue&type=template&id=10a26080&scoped=true&"
import script from "./PermissionTree.vue?vue&type=script&lang=js&"
export * from "./PermissionTree.vue?vue&type=script&lang=js&"
import style0 from "./PermissionTree.vue?vue&type=style&index=0&id=10a26080&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a26080",
  null
  
)

export default component.exports